module.exports = __webpack_public_path__ + "img/loading.2299ad0b.gif";